"use strict";
/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityState = exports.FlushMode = void 0;
/**
 * Runtime flush mode handling
 */
var FlushMode;
(function (FlushMode) {
    /**
     * In Immediate flush mode the runtime will immediately send all operations to the driver layer.
     */
    FlushMode[FlushMode["Immediate"] = 0] = "Immediate";
    /**
     * When in TurnBased flush mode the runtime will buffer operations in the current turn and send them as a single
     * batch at the end of the turn. The flush call on the runtime can be used to force send the current batch.
     */
    FlushMode[FlushMode["TurnBased"] = 1] = "TurnBased";
})(FlushMode = exports.FlushMode || (exports.FlushMode = {}));
/**
 * This tells the visibility state of a Fluid object. It basically tracks whether the object is not visible, visible
 * locally within the container only or visible globally to all clients.
 */
exports.VisibilityState = {
    /** Indicates that the object is not visible. This is the state when an object is first created. */
    NotVisible: "NotVisible",
    /**
     * Indicates that the object is visible locally within the container. This is the state when an object is attached
     * to the container's graph but the container itself isn't globally visible. The object's state goes from not
     * visible to locally visible.
     */
    LocallyVisible: "LocallyVisible",
    /**
     * Indicates that the object is visible globally to all clients. This is the state of an object in 2 scenarios:
     * 1. It is attached to the container's graph when the container is globally visible. The object's state goes from
     *    not visible to globally visible.
     * 2. When a container becomes globally visible, all locally visible objects go from locally visible to globally
     *    visible.
     */
    GloballyVisible: "GloballyVisible",
};
//# sourceMappingURL=dataStoreContext.js.map